export default {
	byKey: {
		asc: {
			key: 'asc',
			data: {
				nameDisplay: 'Ascending',
				tracks: ['51'],
			},
		},
	},
};
